import type { IPathBaseParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { IFileBasedExamResponse } from "@api/courses/exams/fileBased/types";
import type { IExamsGetAllParams } from "@api/exams/types";
import type { IInteractiveExamResponse } from "@api/courses/exams/interactive/types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IFileBasedExamResponse | IInteractiveExamResponse>>,
  IPathBaseParam,
  IPaginationParams & IExamsGetAllParams
>("exams");

export const exams = {
  ...getAllApis,
};
